import { Component, Input, OnInit, ViewChild, EventEmitter, Output } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ConfirmDialogService, Destroyable, SaveForm, untilDestroy } from '@tokeet-frontend/tv3-platform'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { MatSort } from '@angular/material/sort'
import { RxwebValidators } from '@rxweb/reactive-form-validators'
import { localeCompareSort } from '@tokeet-frontend/tv3-platform'
import { Store, select } from '@ngrx/store'
import { Actions, ofType } from '@ngrx/effects'
import { UpdateAISettings, UpdateAISettingsComplete } from '../../store/ai-settings.actions'
import { selectAISettingsIsSaving } from '../../store/ai-settings.selectors'

interface Website {
  url: string
  title: string
}

@Component({
  selector: 'ai-responder-websites',
  templateUrl: './ai-responder-websites.component.html',
  styleUrls: ['./ai-responder-websites.component.scss'],
})
export class AiResponderWebsitesComponent extends Destroyable implements OnInit {
  @ViewChild('paginator') set paginator(p: MatPaginator) {
    this.dataSource.paginator = p
  }
  @ViewChild(MatSort) set sort(s: MatSort) {
    this.dataSource.sort = s
  }

  @Input() set websites(urls: string[]) {
    this.urls = urls?.map((url) => ({ url, title: '' })) || []
    this.dataSource.data = this.urls
  }
  displayedColumns = ['url', 'edit']

  dataSource = new MatTableDataSource<Website>()

  form = this.fb.group({
    url: [null, [Validators.required, RxwebValidators.url()]],
  })

  urls: Website[] = []
  isLoading$ = this.store.pipe(select(selectAISettingsIsSaving))
  constructor(
    private store: Store<any>,
    private actions: Actions,
    private fb: FormBuilder,
    private confirm: ConfirmDialogService
  ) {
    super()
  }

  ngOnInit(): void {
    this.dataSource.sortData = localeCompareSort
    this.actions.pipe(ofType(UpdateAISettingsComplete), untilDestroy(this)).subscribe(() => {
      this.form.reset()
    })
  }

  @SaveForm()
  onSave(form: FormGroup) {
    const { url } = this.form.getRawValue()
    this.urls.push({ url, title: '' })
    this.saveWebsites()
  }

  onDelete(el: Website) {
    this.confirm.confirm().subscribe(() => {
      this.urls = this.urls.filter((t) => t.url !== el.url)
      this.saveWebsites()
    })
  }

  saveWebsites() {
    const urls = this.urls.map((t) => t.url)
    this.store.dispatch(
      UpdateAISettings({
        payload: { urls },
        message: $localize`Websites saved successfully`,
      })
    )
  }
}
